import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useState } from 'react';
import Checkbox from '../Checkbox/Checkbox.js';
import { MultiSelect as MultiSelect$2, Content, Label, SelectedValuesContainer, SelectedValues, Overlay, Options } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Icon from '../Icon/Icon.js';
import { ICON_UI_CHEVRON_UP } from '../../icons/ICON_UI_CHEVRON_UP.js';
import { ICON_UI_CHEVRON_DOWN } from '../../icons/ICON_UI_CHEVRON_DOWN.js';

var _excluded = ["selected", "label", "options", "disabled", "invalid", "onChange", "uniqueId", "noneSelectedLabel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MultiSelect = function MultiSelect(_ref) {
  var _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? [] : _ref$selected,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? null : _ref$options,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$invalid = _ref.invalid,
    invalid = _ref$invalid === void 0 ? false : _ref$invalid,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    uniqueId = _ref.uniqueId,
    _ref$noneSelectedLabe = _ref.noneSelectedLabel,
    noneSelectedLabel = _ref$noneSelectedLabe === void 0 ? '' : _ref$noneSelectedLabe,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState({
      open: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  if (typeof uniqueId !== 'string' || typeof onChange !== 'function' || !Array.isArray(options) || !Array.isArray(selected) || typeof noneSelectedLabel !== 'string') {
    return false;
  }
  var getSelected = function getSelected() {
    if (state.pendingSelection) {
      return state.pendingSelection;
    }
    var selectedDictionary = {};
    selected.forEach(function (key) {
      selectedDictionary[key] = true;
    });
    return selectedDictionary;
  };
  var toggleOpen = function toggleOpen() {
    if (disabled) {
      setState({
        open: false,
        pendingSelection: null
      });
      return;
    }
    var selectedOptions = getSelected();
    if (state.open) {
      onChange(Object.keys(selectedOptions).filter(function (key) {
        return selectedOptions[key];
      }));
      setState({
        open: false,
        pendingSelection: null
      });
    } else {
      setState({
        open: true,
        pendingSelection: selectedOptions
      });
    }
  };
  var handleKeyDown = function handleKeyDown(e) {
    switch (e.keyCode) {
      case 13:
      case 32:
        toggleOpen();
        break;
    }
  };
  var checkboxChange = function checkboxChange(key) {
    setState({
      open: state.open,
      pendingSelection: _objectSpread(_objectSpread({}, state.pendingSelection), {}, _defineProperty({}, key, !state.pendingSelection[key]))
    });
  };
  var hasNoLabel = !label || label.length < 1;
  var selectedDictionary = getSelected();
  var selectedValues = options.filter(function (opt) {
    return selectedDictionary[opt.key];
  }).map(function (opt) {
    return opt.value;
  }).join(', ') || noneSelectedLabel;
  var openIconPath = state.open ? ICON_UI_CHEVRON_UP : ICON_UI_CHEVRON_DOWN;
  return /*#__PURE__*/jsxs(MultiSelect$2, _objectSpread(_objectSpread({}, rest), {}, {
    disabled: disabled,
    hasNoLabel: hasNoLabel,
    children: [/*#__PURE__*/jsxs(Content, {
      tabIndex: "0",
      invalid: invalid,
      disabled: disabled,
      onClick: toggleOpen,
      onKeyUp: handleKeyDown,
      type: "button",
      children: [label && /*#__PURE__*/jsx(Label, {
        disabled: disabled,
        children: label
      }), /*#__PURE__*/jsxs(SelectedValuesContainer, {
        disabled: disabled,
        children: [/*#__PURE__*/jsx(SelectedValues, {
          children: selectedValues
        }), /*#__PURE__*/jsx(Icon, {
          path: openIconPath,
          className: "sg-multi-select__arrow-icon"
        })]
      })]
    }), state.open && /*#__PURE__*/jsx(Overlay, {
      onClick: toggleOpen
    }), /*#__PURE__*/jsx(Options, {
      invalid: invalid,
      disabled: disabled,
      hidden: !state.open,
      children: !disabled && options.map(function (opt) {
        return /*#__PURE__*/jsx(Checkbox, {
          className: "sg-multi-select__option-check-box",
          uniqueId: "".concat(uniqueId, "_").concat(opt.key),
          checked: selectedDictionary[opt.key],
          onChange: function onChange() {
            return checkboxChange(opt.key);
          },
          children: opt.value
        }, opt.key);
      })
    })]
  }));
};
var MultiSelect$1 = MultiSelect;

export { MultiSelect$1 as default };
//# sourceMappingURL=MultiSelect.js.map
